import { object, string } from 'zod';

import { makeZodValidate as makeValidate } from '@occc/ui-forms';

const schema = object({
  name: string(),
});

export const validateLocationGroup = makeValidate(schema);
